/**
 *    @author:
 *    @since:
 *
 */
import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { Address, Contact } from '../_common/data/input-data';
import { ContactInfoAndMailingAddressComponent} from './contact_info_and_mailing_address.component';

export class ContactInfoAndMailingAddressValidation extends IValidator {

       constructor(private component: ContactInfoAndMailingAddressComponent,private menuID:number) {
             super();
             this.viewportScroller = this.component.viewportScroller;
             this.contact.copyFrom(this.component.data.contact);
             this.motherContact.copyFrom(this.component.data.motherContact);
       }

       private contact:Contact = new Contact();
       private motherContact:Contact = new Contact();
 

       private success: boolean;
       
       private viewportScroller:ViewportScroller;

       public validate(): boolean {

            this.success = true;          
            
            //---- [Postal Code] ---
            /**
            if(this.component.data.contact.address.chk_international!='Y'){
                   if ( Util.isEmpty(this.component.data.contact.address.postalCode) ) {
                        this.focus('postalCode','input_postalCodeInput').error_postalCode = "contact_info_and_mailing_address.postalCodeEmpty"; 
                   } else if ( Util.hasSpecialCharacter(this.component.data.contact.address.postalCode)
                        || !Util.postalCodeValidate(this.component.data.contact.address.postalCode)) {
                        this.focus('postalCode','input_postalCodeInput').error_postalCode = "contact_info_and_mailing_address.PostalCodeInvalid";
                   }
            }
             */

            //---- [Phone Number] ---       
            if(this.component.data.contact.address.chk_international!='Y'){
                  if ( Util.isEmpty(this.component.data.contact.phoneArea) 
                              || Util.isEmpty(this.component.data.contact.phoneNumber1) 
                              || Util.isEmpty(this.component.data.contact.phoneNumber2) ) {
                        this.focus('phoneNumber','input_areaCode').error_phoneNumber = "contact_info_and_mailing_address.phoneNumberEmpty";
                  } else if(!Util.isNumeric(this.component.data.contact.phoneArea)
                              || !Util.isNumeric(this.component.data.contact.phoneNumber1)
                              || !Util.isNumeric(this.component.data.contact.phoneNumber2)
                              || this.component.data.contact.phoneArea.toString().length != 3
                              || this.component.data.contact.phoneNumber1.toString().length != 3
                              || this.component.data.contact.phoneNumber2.toString().length != 4){
                        this.focus('phoneNumber','input_areaCode').error_phoneNumber = "contact_info_and_mailing_address.phoneNumberInvalid";                  
                  }  
                  
                  if ( (!Util.isEmpty(this.component.data.contact.daytimePhoneArea) 
                              && (!Util.isNumeric(this.component.data.contact.daytimePhoneArea) || this.component.data.contact.daytimePhoneArea.toString().length != 3))
                        || (!Util.isEmpty(this.component.data.contact.daytimePhoneNumber1) 
                              && (!Util.isNumeric(this.component.data.contact.daytimePhoneNumber1) || this.component.data.contact.daytimePhoneNumber1.toString().length != 3))
                        || (!Util.isEmpty(this.component.data.contact.daytimePhoneNumber2) 
                              && (!Util.isNumeric(this.component.data.contact.daytimePhoneNumber2) || this.component.data.contact.daytimePhoneNumber2.toString().length != 4))){
                              
                        this.focus('phoneNumber','input_daytimePhoneArea').error_daytimePhoneNumber = "contact_info_and_mailing_address.daytimePhoneNumberInvalid";
                        
                  }
                  
                  if(!Util.isEmpty(this.component.data.contact.phoneExt)
                              && !Util.isNumeric(this.component.data.contact.phoneExt)){
                        this.jump('phoneNumber').error_phoneNumber = "contact_info_and_mailing_address.extensionInvalid";
                  }
           
            } else if(this.component.data.contact.address.chk_international=='Y'){
                  if ( Util.isEmpty(this.component.data.contact.phoneArea) 
                              || Util.isEmpty(this.component.data.contact.phoneNumber1) 
                              || Util.isEmpty(this.component.data.contact.phoneNumber2) ) {
                        this.focus('intPhoneNumber','input_countryCode').error_intPhoneNumber = "contact_info_and_mailing_address.intPhoneNumberEmpty"; 
                  } else if(!Util.isNumeric(this.component.data.contact.phoneArea)
                              || !Util.isNumeric(this.component.data.contact.phoneNumber1)
                              || !Util.isNumeric(this.component.data.contact.phoneNumber2)){
                        this.focus('phoneNumber','input_countryCode').error_intPhoneNumber = "contact_info_and_mailing_address.intPhoneNumberInvalid";
                  }
                  
                  if ( (!Util.isEmpty(this.component.data.contact.daytimePhoneArea) 
                              && !Util.isNumeric(this.component.data.contact.daytimePhoneArea))
                        || (!Util.isEmpty(this.component.data.contact.daytimePhoneNumber1) 
                              && !Util.isNumeric(this.component.data.contact.daytimePhoneNumber1))
                        || (!Util.isEmpty(this.component.data.contact.daytimePhoneNumber2) 
                              && !Util.isNumeric(this.component.data.contact.daytimePhoneNumber2))){
                              
                        this.jump('phoneNumber').error_intDaytimePhoneNumber = "contact_info_and_mailing_address.daytimeIntPhoneNumberInvalid";
                  
                  }
            }                                


            return this.success;
       }

       public validate2(validated:boolean) :boolean {
            if ( this.component.data.eligibility.isBornThroughSurrogacy!='Y' ) {

                  if ( Util.isEmpty(this.component.contact.isParentSameAddr) ) {
                       if ( validated ) 
                            this.focus('sameAddress','radio_sameAddressRadio_0').error_sameAddress = "contact_info_and_mailing_address.isMailingAddrSameAsParentAddrEmpty";
                       else this.jump('sameAddress').error_sameAddress = "contact_info_and_mailing_address.isMailingAddrSameAsParentAddrEmpty";
                  }
                        
                  if ( this.component.data.eligibility.isCustodyOtherThanParent !='Y' ) {
                        if ( this.component.contact.isParentSameAddr == 'N' && 
                             Util.isEmpty(this.component.data.motherContact.address.chk_international) ) {
                             if ( validated ) 
                                this.focus('addressType','radio_isCanadianAddressRadio_0').error_selectAddrType = "contact_info_and_mailing_address.isParentAddrCanadianEmpty";
                              else
                                this.jump('addressType').error_selectAddrType = "contact_info_and_mailing_address.isParentAddrCanadianEmpty";
                        }
                  }
            }
            return this.success;
       }
       
       private jump(tagId:string) : ContactInfoAndMailingAddressComponent {
             ///console.log("tagId",tagId);
               if ( this.success )
                    this.viewportScroller.scrollToAnchor(tagId);
               this.success = false;
               return this.component;
       }

       private focus(tagId:string,ctrlId:string) : ContactInfoAndMailingAddressComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let  ctrl = document.getElementById(ctrlId);
                 if ( ctrl ) if ( ctrl ) ctrl.focus();
                 ////else console.log(" Focus:: NOT FOUND :: " + ctrlId )
            }
                 
            this.success = false;
            return this.component;
       }

       public IdOfChanged():number { 

              let inputContact:Contact = this.component.data.contact;
              let inputMotherContact:Contact = this.component.data.motherContact;

              let  result:number = this.changeCheck(this.contact, inputContact);
              if ( result > 0 ) return result;
              
              return this.changeCheck(this.motherContact, inputMotherContact);
       }

       private changeCheck(contact:Contact, inputContact:Contact) : number {
                if ( contact.isParentSameAddr != inputContact.isParentSameAddr 
                  || contact.phoneArea != inputContact.phoneArea 
                  || contact.phoneNumber1 != inputContact.phoneNumber1 
                  || contact.phoneNumber2 != inputContact.phoneNumber2 
                  || contact.phoneExt != inputContact.phoneExt 
                  || contact.daytimePhoneArea != inputContact.daytimePhoneArea 
                  || contact.daytimePhoneNumber1 != inputContact.daytimePhoneNumber1 
                  || contact.daytimePhoneNumber2 != inputContact.daytimePhoneNumber2 
                  || contact.daytimeExt != inputContact.daytimeExt 
                  || contact.needSpecialDelivery != inputContact.needSpecialDelivery 
                   ) return this.menuID;
  
                   let address1:Address = contact.address;
                   let address2:Address = inputContact.address;
                   
                if ( address1.chk_international != address2.chk_international
                  || address1.streetNumber != address2.streetNumber
                  || address1.streetName != address2.streetName
                  || address1.unit != address2.unit
                  || address1.buzz != address2.buzz
                  || address1.poBox != address2.poBox
                  || address1.postalCode != address2.postalCode
                  || address1.deliveryMode != address2.deliveryMode
                  || address1.deliveryAddr != address2.deliveryAddr
                  || address1.base.city != address2.base.city
                  || address1.base.province != address2.base.province
                  || address1.base.country != address2.base.country
                  || address1.base.otherCountry != address2.base.otherCountry
                 ) return this.menuID;

                 return  0;
  
         }
}


